const HTML_CONTENT_REGEX = /^```html\n([\s\S]*?)\n```$/gm;
const HTML_WRAPPED_REGEX = /^<html>[\s\S]*<\/html>$/i;

export const isHtmlContent = (text: string): boolean =>
  HTML_CONTENT_REGEX.test(text) || HTML_WRAPPED_REGEX.test(text);

export function extractHtmlContent(responseText: string): string {
  // Normalize BR tags: remove invalid closing tags and standardize to <br />
  return responseText
    .replace(HTML_CONTENT_REGEX, "$1")
    .trim()
    .replace(/<\/?\s*br\s*>/gi, match =>
      match.startsWith("</") ? "" : "<br />",
    )
    .replace(/<br\s*\/?>/gi, "<br />");
}

export const isElement = (node: ChildNode): node is Element =>
  node.nodeType === Node.ELEMENT_NODE;

// Tokenize HTML content into an array of tokens
export const tokenizeHtml = (html: string): string[] => {
  const div = document.createElement("div");
  div.innerHTML = html;

  const tokens: string[] = [];
  const OPENING_TAG_REGEX = /^<[^>]+>/;
  const walkNodes = (node: ChildNode) => {
    if (node.nodeType === Node.TEXT_NODE) {
      const words = (node.textContent || "").match(/\S+\s*/g) || [];
      tokens.push(...words);
    } else if (isElement(node)) {
      tokens.push(OPENING_TAG_REGEX.exec(node.outerHTML)?.[0] || "");

      node.childNodes.forEach(walkNodes);

      const tagName = node.tagName.toLowerCase();
      tokens.push(`</${tagName}>`);
    }
  };

  div.childNodes.forEach(walkNodes);
  return tokens;
};
